import { ForgotPassword } from "@/pages/Auth/ForgotPassword";
import { Login } from "@/pages/Auth/Login";
import { Register } from "@/pages/Auth/Register/Register";
import { ResetPassword } from "@/pages/Auth/ResetPassword";
import { VerifyPassword } from "@/pages/Auth/VerifyPassword";

import { Screen404 } from "@/pages/404/404";
import ImpToken from "@/pages/ImpToken/ImpToken";
import { InvitationAffiliateConfirm } from "@/pages/InvitationAffiliateConfirm/InvitationAffiliateConfirm";
import { InvitationAffiliateLink } from "@/pages/InvitationAffiliateLink/InvitationAffiliateLink";
import { InvitationPartnerConfirm } from "@/pages/InvitationPartnerConfirm/InvitationPartnerConfirm";
import { InvitationPartnerLink } from "@/pages/InvitationPartnerLink/InvitationPartnerLink";
import { InvitationAcceptInvite } from "@/pages/InvitationAcceptInvite/InvitationAcceptInvite";
import { InvitationAcceptConfirm } from "@/pages/InvitationAcceptInvite/InvitationAcceptConfirm";
import SentryExamplePage from "@/pages/SentryExamplePage";
import EmailVerified from "@/pages/VerificatedEmail/VerificatedEmail";
import VerifyEmail from "@/pages/VerifyEmail/VerifyEmail.tsx";
import { existingRoutes } from "@/utils/existingRoutes";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

export default function OutsideRoutes() {
  const currentPath = location.pathname;

  const redirectToLogin = () => {
    if (existingRoutes[currentPath]) {
      return <Navigate to="/login" state={{ from: currentPath }} replace />;
    } else {
      return <Screen404 />;
    }
  };

  const router = createBrowserRouter([
    { path: "/", element: <Navigate to="/login" replace /> },
    { path: "/login", element: <Login /> },
    { path: "/register", element: <Register /> },
    { path: "/forgot-password", element: <ForgotPassword /> },
    { path: "/verify-password", element: <VerifyPassword /> },
    { path: "/verify-email", element: <VerifyEmail /> },
    { path: "/email-verified", element: <EmailVerified /> },
    { path: "/password-reset/:token", element: <ResetPassword /> },
    { path: "/by-imp", element: <ImpToken /> },

    {
      path: "/invitation-affiliate/:productId",
      element: <InvitationAffiliateLink />,
    },
    {
      path: "/invitation-affiliate-confirm",
      element: <InvitationAffiliateConfirm />,
    },
    {
      path: "/invitation-partner/:productId",
      element: <InvitationPartnerLink />,
    },
    {
      path: "/invitation-partner-confirm",
      element: <InvitationPartnerConfirm />,
    },
    {
      path: "/invitation-accept/:token",
      element: <InvitationAcceptInvite />,
    },
    {
      path: "/invitation-accept-confirm",
      element: <InvitationAcceptConfirm />,
    },
    {
      path: "/sentry-example-page",
      element: <SentryExamplePage />,
    },
    { path: "*", element: redirectToLogin() },
  ]);

  return <RouterProvider router={router} />;
}
